<table class="result-table">
  <thead>
    <tr>
      <th colspan="7" class="result-table-title">Internal test result</th>
    </tr>
    <tr class="result-table-col-headers">
      <th class="col-date" title="Date and time when the test was triggered, in the browser's time zone">Date</th>
      <th class="col-dlr-status" title="DLR status / Receipt status from our test number">DLR/Rec. Status</th>
      <th class="col-sender" title="Sender ID of the delivered SMS">Sender</th>
      <th class="col-text" title="Text of the delivered SMS">Text</th>
      <th class="col-phone" title="The destination to which the test was sent">Phone</th>
      <th class="col-supplier" title="Supplier via which the test was sent">Supplier</th>
      <th class="col-dlr-delay" title="Delays in getting the SMPP DLR status and Receipt status">DLR/Rec. Delay</th>
    </tr>
  </thead>
  <tbody>
    @if (loading()) {
      <tr>
        <td colspan="7" class="result-table-loading">
          <div class="sk-spinner sk-spinner-pulse"></div>
        </td>
      </tr>
    }
    @for (result of rowData(); track result.id) {
      <tr>
        <td [innerHTML]="renderDate(result)"></td>
        <td class="text-center" [innerHTML]="renderDlrStatus(result)"></td>
        <td [innerHTML]="renderSender(result)"></td>
        <td [innerHTML]="renderText(result)"></td>
        <td>{{ result.destinationDto?.phone }}</td>
        <td [innerHTML]="renderSupplier(result)"></td>
        <td [innerHTML]="renderDelay(result)"></td>
      </tr>
    }
  </tbody>
  <tfoot>
    <tr>
      <td colspan="7" class="result-table-footer">
        <a class="info-toggle-link" (click)="infoExpanded = !infoExpanded">
          <span class="icon-help-1 text-primary-p8"></span>
          <span>{{ infoExpanded ? 'Hide' : 'About internal test results' }}</span>
        </a>
        @if (infoExpanded) {
          <p class="info-toggle-content text-muted mt-0_5 mb-0">
            The internal test results represent only part of the information used to evaluate a test number's reliability
            during the test TTL. This is because the internal test is only triggered once the report is submitted, which means
            there is some delay between the original (reported) test and the internal test.
          </p>
        }
      </td>
    </tr>
  </tfoot>
</table>
